import React from "react"
import "../index.less"
import { store as UKStore } from "../../../page/uk/store"
import { store as BondStore } from "../../../page/bond/store"
import { Observer } from "mobx-react-lite"
import { PageBondType, PageType, StockSubType } from "../../pagetype"
import { UKTimeTrade } from "../../../page/uk/uk_time_trade"
import { ATimeTrade } from "../../../page/a/time_trade"
import { BTimeTrade } from "../../../page/b/time_trade"
import { quotedata } from "../../quotedata"
import { BondTimeTrade } from "../../../page/bond/time_trade"
import { HKTimeTrade } from "../../../page/hk/time_trade"
import { ForexTimeTrade } from "../../../page/forex/time_trade"
import { FundTimeTrade } from "../../../page/fund/fund_time_trade"
import { GlobalBondTimeTrade } from "../../../page/tips/time_trade"
import { CHTimeTrade } from "../../../page/ch/ch_time_trade"

export function TimeTrade(props: { pagetype: PageType; quotedata: quotedata; stocksubtype: StockSubType; bondsubtype?: PageBondType }) {
  return (
    <Observer>
      {() => (
        <>
          {props.pagetype == PageType.沪深A股 && <ATimeTrade quotedata={props.quotedata} stocksubtype={props.stocksubtype}/>}
          {props.pagetype == PageType.B股 && <BTimeTrade quotedata={props.quotedata} />}
          {props.pagetype == PageType.英股 && UKStore.StockDetail && <UKTimeTrade quotedata={props.quotedata} />}
          {props.pagetype == PageType.瑞士GDR && <CHTimeTrade quotedata={props.quotedata} />}
          {props.pagetype == PageType.债券 && BondStore.StockDetail && <BondTimeTrade quotedata={props.quotedata} bondsubtype={props.bondsubtype!} />}
          {props.pagetype == PageType.港股 && <HKTimeTrade quotedata={props.quotedata} />}
          {props.pagetype == PageType.外汇 && <ForexTimeTrade quotedata={props.quotedata} />}
          {props.pagetype == PageType.场内基金 && <FundTimeTrade quotedata={props.quotedata} />}

          {(props.stocksubtype == StockSubType.国债个券 || props.stocksubtype == StockSubType.预发行个券) && <GlobalBondTimeTrade quotedata={props.quotedata} />}
        </>
      )}
    </Observer>
  )
}
